import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { SiGoodreads } from "react-icons/si";
import React from "react";

export default function Contact() {
  
    return (
        <section id="contact" className="relative py-20">
          <div className="container px-5 mx-auto flex flex-col items-center justify-center">
            <div className="flex flex-col items-center gap-8">
              <a
                href="mailto:nwlvrd@umich.edu"
                className="px-8 py-4 bg-indigo-600 hover:bg-indigo-700 text-white text-lg font-semibold rounded-lg shadow-lg transition"
              >
                Contact Me
              </a>
              <div className="flex justify-center gap-8">
                <a
                  href="https://www.linkedin.com/in/nicholas-walvoord/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin className="text-blue-500 hover:text-blue-700 w-8 h-8" />
                </a>
                <a
                  href="https://github.com/nwlvrd"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaGithub className="text-white hover:text-gray-300 w-8 h-8"/>
                </a>
                <a
                  href="https://www.goodreads.com/user/show/192265954-nicholas-walvoord"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SiGoodreads className="text-orange-400 hover:text-orange-300 w-8 h-8"/>
                </a>
              </div>
            </div>
          </div>
        </section>
      );
    }